/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */
import {Vue} from 'vue-property-decorator';
import {MutationTree} from 'vuex';
import moment from 'moment';
import {
    ChallengeAchievementInterface,
    SpeciesAchievementInterface,
    TrophyCabinetMode,
    TrophyStateInterface,
} from '@/store/modules/trophy-cabinet/types';

/**
 * Trophy cabinet mutations.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const mutations: MutationTree<TrophyStateInterface> = {
    /**
     * @param {TrophyStateInterface} state
     */
    start(state: TrophyStateInterface): void {
        Vue.set(state.loadStatus, 'loading', true);
        Vue.set(state.loadStatus, 'error', false);
        Vue.set(state.loadStatus, 'success', false);
    },

    /**
     * @param {TrophyStateInterface} state
     * @param {boolean} success
     */
    stop(state: TrophyStateInterface, success: boolean = true): void {
        Vue.set(state.loadStatus, 'loading', false);
        Vue.set(state.loadStatus, 'error', !success);
        Vue.set(state.loadStatus, 'success', success);
    },

    /**
     * @param {TrophyStateInterface} state
     * @param {SpeciesAchievementInterface[]} achievements
     */
    setSpeciesAchievements(
        state: TrophyStateInterface,
        achievements: SpeciesAchievementInterface[],
    ): void {
        Vue.set(state, 'speciesAchievements', achievements);
        Vue.set(state, 'timestamp', moment().unix());
    },

    /**
     * @param {TrophyStateInterface} state
     * @param {ChallengeAchievementInterface} achievements
     */
    setCommunityChallengeAchievements(
        state: TrophyStateInterface,
        achievements: ChallengeAchievementInterface,
    ): void {
        Vue.set(state, 'challengeAchievements', achievements);
    },

    /**
     * @param {TrophyStateInterface} state
     */
    reset(state: TrophyStateInterface): void {
        Vue.set(state, 'speciesAchievements', []);
        Vue.set(state, 'timestamp', 0);
        Vue.set(state, 'loadStatus', {loading: false, error: false, success: false});
    },

    /**
     * Update the mode of the state.
     * @param {TrophyStateInterface} state
     * @param {TrophyCabinetMode} mode
     */
    setMode(state: TrophyStateInterface, mode: TrophyCabinetMode): void {
        Vue.set(state, 'mode', mode);
    },
};
